import { Fetch } from "../../utils/fetch";
import { routes } from "./routes";
import { UserPayloadI } from "./profileTypes";

class ProfileService {
  getUserInformation() {
    return Fetch("get", routes.userInformation);
  }

  updateInformation(payload: UserPayloadI) {
    return Fetch("patch", routes.userInformation, payload);
  }

  updateAvatar(payload: FormData) {
    return Fetch("patch", routes.userInformation, payload, { contentType: "multipart/form-data" });
  }
}

export default new ProfileService();
